import { h } from 'preact';
import { useState } from 'preact/hooks';
import clsx from 'clsx';
import CaretDown from '../utils/icon/caret-down.svg';

const MobileMenuList = ({ menuList, index }) => {
  const [opened, setOpened] = useState(false);
  return (
    <div
      key={index}
      className="w-full laptop:w-auto border border-t-0 border-l-0 border-r-0 border-black-30 laptop:border-0"
      style={{order: menuList.index}}
    >
      <p
        className="font-14-bold text-black laptop:mb-[13px] p-[21px] laptop:p-0 laptop:inline-block flex justify-between items-center"
        onClick={() => setOpened(!opened)}
      >
        <span>{menuList.handle}</span>
        <CaretDown
          className={clsx('block laptop:hidden', opened && 'rotate-180')}
        />
      </p>
      <ul
        className={clsx(
          'overflow-hidden transition-all duration-300 px-[21px] laptop:px-0',
          opened ? '!max-h-[1000px] mb-4' : 'max-h-0',
        )}
      >
        {menuList.links.length > 0 &&
                  menuList.links.map((link) => (
                    <li key={link.label} className="mb-5">
                      <a href={link.url} className="font-14 text-charcoal">
                        {link.label}
                      </a>
                    </li>
                  ))}
                {menuList.url && (
                  <li className="mb-5">
                    <a href={menuList.url} className="font-14 text-charcoal underline">
                      {window.TMW?.Strings?.header?.shopAll}
                    </a>
                  </li>
                )}
      </ul>
    </div>
  );
};

export default MobileMenuList;